import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const OrthopedicsAndTraumatologyIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M79.5 40C79.5 61.8153 61.8153 79.5 40 79.5C18.1848 79.5 0.5 61.8153 0.5 40C0.5 18.1848 18.1848 0.5 40 0.5C61.8153 0.5 79.5 18.1848 79.5 40Z'
      />
      <g clipPath='url(#clip0_414_10004)'>
        <path
          d='M40.1663 46.746C37.219 49.9244 35.1223 52.5756 33.9954 54.0013C33.4534 54.6858 33.2581 54.9309 33.0979 55.091C32.4563 55.7325 32.219 56.6642 32.4768 57.5225C33.0911 59.5731 32.5344 61.7848 31.0237 63.2945C29.928 64.3901 28.4719 64.9935 26.9231 64.9935C27.0975 64.9935 24.7257 65.1985 22.8215 63.2945C21.6838 62.1578 21.0413 60.5993 21.1321 58.8544C19.3235 58.9491 17.6956 58.2559 16.5344 57.0021C14.4885 54.7943 14.4885 51.3346 16.5344 49.1258C18.0647 47.4736 20.3528 46.8594 22.5042 47.5224C23.3342 47.7782 24.2502 47.5351 24.8958 46.8897C25.0569 46.7285 25.302 46.5332 25.9875 45.9904C27.4124 44.8645 30.0647 42.767 33.2424 39.8209C33.593 39.4957 34.0813 39.3619 34.5481 39.4635L38.5383 40.3277C39.0934 40.4476 39.5385 40.8854 39.6604 41.4496L40.5237 45.4395C40.6252 45.9073 40.4915 46.3946 40.1663 46.746Z'
          fill='#D5E8FE'
        />
        <path
          d='M63.299 31.0219C61.7892 32.5325 59.5783 33.0891 57.5285 32.4759C56.6672 32.2171 55.7365 32.4544 55.0949 33.0959C54.9328 33.2571 54.675 33.4651 53.9504 34.0402C52.3293 35.3301 48.9543 38.0144 45.3195 41.5131C44.4904 42.3079 43.1144 41.8862 42.8723 40.7671L42.2238 37.7762C42.2228 37.7742 42.2219 37.7723 42.2199 37.7694C42.218 37.7684 42.217 37.7664 42.215 37.7645L39.2209 37.1161C38.1027 36.874 37.6808 35.4942 38.4758 34.6681C41.9699 31.0395 44.6535 27.6657 45.9426 26.0448C46.5207 25.3174 46.7297 25.0576 46.8918 24.8946C47.5383 24.2491 47.7814 23.3322 47.5256 22.5041C46.8625 20.352 47.4767 18.0641 49.1291 16.5339C51.343 14.4853 54.8019 14.4921 57.006 16.5339C58.258 17.694 58.9533 19.3208 58.8586 21.1312C60.5998 21.0404 62.1594 21.68 63.299 22.8204C65.5666 25.0879 65.5666 28.7545 63.299 31.0219Z'
          fill='#D5E8FE'
        />
        <path
          d='M30.347 36.9994L25.6157 35.3943C24.8496 35.1344 24.4393 34.3027 24.6991 33.5367C24.9592 32.7705 25.7911 32.3605 26.557 32.6203L31.2883 34.2253C32.0544 34.4852 32.4648 35.3169 32.2049 36.0829C31.9449 36.8487 31.1133 37.2593 30.347 36.9994Z'
          fill='#FF884D'
        />
        <path
          d='M34.5329 30.9811L32.9276 26.2504C32.6678 25.4844 33.0781 24.6526 33.8442 24.3928C34.6108 24.1328 35.4421 24.5433 35.7022 25.3092L37.3074 30.0399C37.5673 30.806 37.1569 31.6377 36.3908 31.8976C35.6246 32.1574 34.7929 31.7473 34.5329 30.9811Z'
          fill='#FF884D'
        />
        <path
          d='M44.5944 54.3708L42.9892 49.6401C42.7293 48.874 43.1397 48.0423 43.9058 47.7824C44.6719 47.5225 45.5035 47.9326 45.7637 48.6989L47.3689 53.4296C47.6288 54.1956 47.2185 55.0274 46.4523 55.2872C45.6861 55.5472 44.8545 55.1368 44.5944 54.3708Z'
          fill='#FF4D4D'
        />
        <path
          d='M53.7391 47.0599L49.0078 45.4549C48.2417 45.195 47.8314 44.3633 48.0912 43.5972C48.3512 42.8311 49.1833 42.421 49.9491 42.6808L54.6803 44.2859C55.4464 44.5458 55.8567 45.3775 55.5969 46.1435C55.337 46.9093 54.5055 47.3199 53.7391 47.0599Z'
          fill='#FF4D4D'
        />
        <path
          d='M40.5236 45.4397C40.6252 45.9075 40.4914 46.3947 40.1662 46.7462C37.2189 49.9247 35.1223 52.5758 33.9953 54.0015C33.4533 54.686 33.258 54.9311 33.0978 55.0913C32.4562 55.7328 32.2189 56.6644 32.4768 57.5227C33.091 59.5733 32.5344 61.785 31.0236 63.2947C29.9279 64.3903 28.4719 64.9937 26.923 64.9937C27.0975 64.9937 24.7257 65.1987 22.8215 63.2947C21.6838 62.1581 21.0412 60.5996 21.132 58.8546L39.264 40.7244C39.6713 41.1317 39.589 41.1201 40.5236 45.4397Z'
          fill='#B5DBFF'
        />
        <path
          d='M63.2993 31.0218C61.7896 32.5324 59.5786 33.089 57.5288 32.4758C56.6675 32.217 55.7368 32.4543 55.0952 33.0958C54.9331 33.257 54.6753 33.465 53.9507 34.0401C52.3296 35.33 48.9546 38.0143 45.3198 41.513C44.4907 42.3078 43.1147 41.8861 42.8726 40.767L42.2241 37.7761C42.2231 37.7741 42.2222 37.7722 42.2202 37.7693L58.8589 21.1311C60.6001 21.0403 62.1597 21.6799 63.2993 22.8203C65.5669 25.0878 65.5669 28.7544 63.2993 31.0218Z'
          fill='#B5DBFF'
        />
      </g>
      <defs>
        <clipPath id='clip0_414_10004'>
          <rect width='50' height='50' fill='white' transform='translate(15 15)' />
        </clipPath>
      </defs>
    </svg>
  )
);
OrthopedicsAndTraumatologyIcon.displayName = 'OrthopedicsAndTraumatologyIcon';

export default OrthopedicsAndTraumatologyIcon;
